import React from 'react';
import * as util from '../../utils';
import Layout from '../Layout';
import './index.less';
import './markdown.css';
import marked from 'marked'
import noFile from '../../images/no-file.png'
import img from '../../images/package.png'
import {Message, Row, Col, Icon, Tag, Loading, Table, Pagination, FormControl,Button} from 'tinper-bee';
import DatePicker from 'bee-datepicker';
import 'bee-datepicker/build/DatePicker.css';
const RangePicker = DatePicker.RangePicker
const ReactMarkdown = require('react-markdown');
interface Tab {
    key: string,
    name: string
}

class CollectionsDetail extends React.Component<any, any> {
    state = {
        activeTab: 'readMe',
        loading: true,
        readMeFile: '',
        packageDetail: {
            id: undefined,
            changeLog: undefined,
            nexus: '',
            API: '',
            name: ''
        },
        apiFile: '',
        searchVersion: '',
        changeLogFile: '',
        historyList: [],
        searchTime: [],
        paginationInfo: {},
        packageName: '',
        colors: ['success', 'info', 'warning', 'danger'],
        showAddIcon: false,
        userList: [],
        page: 1,
        pageSize: 20,
        visible: false,
        transferCreatorId: '',
    };

    tabs: Tab[] = [
        {
            key: 'readMe',
            name: '基本信息'
        },
    ];

    pageSizes = [
        5, 10, 15, 20
    ]

    historyColumns = [
        { title: "版本号", dataIndex: "version", key: "version", width: 275 },
        { title: "CDN", dataIndex: "CDN", key: "CDN", width:670, render: (text) => <a target="_blank" href={text}>{text}</a>},
        { title: "更新时间", dataIndex: "creatTime", key: "creatTime", width: 175}
    ]
    searchVersion(){
        this.setState({page: 1}, () => this.getHistoryList())
    }
    async getHistoryList() {
        const { page, pageSize, packageName, searchTime, searchVersion } = this.state;
        const startTime: any = searchTime[0];
        const endTime: any = searchTime[1];
        const res = await util.get('/package/packageHistory', {
            packagename: packageName,
            pageNumber: page,
            version: searchVersion,
            startTime: startTime ? startTime.format('YYYY-MM-DD'): undefined,
            endTime: endTime ? endTime.format('YYYY-MM-DD'): undefined,
            pageSize,
            auth:1
        })
        if(res.status === 200) {
            this.setState({historyList: res.data.list, paginationInfo: res.data.pageInfo})
        }
    }
    onChangeTab = async tab => {
        this.setState({
            activeTab: tab
        });
        if (tab === 'cdn') {
           this.getHistoryList()
        } else if(tab === 'api' || tab === 'changeLog') {
            const res = await util.get('/package/getMD', {
                id: this.state.packageDetail.id,
                type: tab
            });
            this.setState({
                [tab === 'api' ? 'apiFile' : 'changeLogFile']: marked(res)
            })
        }
    };
    async sync() {
        const packageName = this.state.packageName;
        Message.create({content: "组件同步任务已开启，请稍后！", color: 'success'});
        const packageData: any = await util.post(`/package/sync`, {id: this.state.packageDetail.id, name: packageName});
        if(packageData.status === 200) {
            Message.create({content: "组件同步成功！", color: 'success'});
            this.getDetail();
        } else {
            Message.create({content: "组件同步任务未返回结果，请过一会刷新查看同步结果！", color: 'danger'});
        }
    }
    async getDetail (packageName?){
        packageName = packageName || this.state.packageName;
        const packageData: any = await util.get(`/package/packageDetail?packagename=${packageName}`);
        let readMeFile = '';
        const {data} = packageData;
        if (packageData.status  === 200) {
            if (data.readmeFile) {
                readMeFile = marked(await util.get(`/package/readMeFile?id=${data.id}`));
            }
        } else {
            this.setState({noData: true});
            return;
        }
        const nexus = data.nexus;
        if(nexus !== 'cli') {
            this.historyColumns[1].title = '下载源码';
            this.historyColumns[1].width = 200;
            this.historyColumns[1].render = (text) => {
                return <a href={text}><Icon type="uf-cloud-down" /></a>
            }
        }
        this.setState({
            packageDetail: data,
            loading: false,
            readMeFile,
            showAddIcon: true
        });
        if(packageData.data.nexus === 'npm') {
            const npmReadme: any = await util.get(`/package/getNpmReadme?packagename=${packageName}`);
            const div = document.createElement('div');
            div.innerHTML = npmReadme.data;
            div.style.display = 'none';
            document.body.appendChild(div);
        }
    }
    async componentDidMount() {
        let packageName: undefined | string = undefined;
        let {org, name} = this.props.match.params;
        if (org) {
            packageName = org + '/' + name;
        } else {
            packageName = name;
        }
        this.getDetail(packageName);
        this.setState({ packageName: packageName})
    }

    pageChange = page => {
        this.setState({
            page
        }, () => this.getHistoryList())
    }

    dataNumSelect = page => {
        const pageSize = this.pageSizes[page]
        this.setState({
            pageSize
        }, async () => {
            const { page, pageSize, packageName } = this.state
            const res = await util.get('/package/packageHistory', {
                packagename: packageName,
                pageNumber: page,
                pageSize,
                auth:1
            })
            if(res.status === 200) {
                this.setState({historyList: res.data.list, paginationInfo: res.data.pageInfo})
            }
        })
    }

    renderHeader = (packageDetail, loading) => {
        return <React.Fragment>
                <div className='img'>
                    {
                        packageDetail.img ? <img src={packageDetail.img} /> : <img src={img} />
                    }
                </div>
                <div className='intro'>
                    <p className='title'>{packageDetail.name}</p>
                    <div className='info1'>
                        <p>
                            <span>来源：</span>
                            <span className='red'>{packageDetail.nexus}</span>
                        </p>
                        <p>
                            <span>更新时间：</span>
                            <span className='red'>{packageDetail.latestTime}</span>
                        </p>
                    </div>
                    <p className='info'>{packageDetail.info}</p>
                    <div className='info2'>
                        <div>
                            <span>版本</span>
                            <span className='black'>{packageDetail.latestVersion}</span>
                        </div>
                        <div>
                            <span>下载量</span>
                            <span className='black'>{packageDetail.download}</span>
                        </div>
                        <div>
                            <span>访问量</span>
                            <span className='black'>{packageDetail.visitVolume || "未获取"}</span>
                        </div>
                        <div>
                            <span>大小</span>
                            <span className='black'>{(packageDetail.size / 1024).toFixed(2)}KB</span>
                        </div>
                    </div>
                </div>
        </React.Fragment>;
    };


    renderInfos = (packageDetail, loading) => {
        const {activeTab, readMeFile, apiFile, changeLogFile} = this.state;
        let result = null;
        switch (activeTab) {
            case 'readMe': {
                return <div id='npmInfo'>
                    {
                        readMeFile ?  <article className="markdown-body">
                            <div dangerouslySetInnerHTML={{__html: readMeFile}}/>
                        </article>  : <img className='noFile' src={noFile} />
                    }
                    {
                        (() => {
                            if(!readMeFile) {
                                const render = () => {
                                    setTimeout(() => {
                                        const readme: any = document.getElementById('readme')
                                        const readmeDom = readme && readme.cloneNode(true);
                                        const DOM: any = document.getElementById('npmInfo');
                                        if(DOM && readme) {
                                            DOM.innerHTML = '';
                                            console.log(readmeDom)
                                            DOM.appendChild(readmeDom)
                                        }
                                    }, 100)
                                }
                                render();
                            }
                        })()
                    }
                </div>
            }
            case 'demo': {
                const {packageDetail} = this.state;
                const packageName = packageDetail.name
                const url = `http://bee.tinper.org/tinper-bee/${packageName}/dist/demo.js` // 临时做法，之后会取接口中的demo url
                const cssUrl = `http://bee.tinper.org/tinper-bee/${packageName}/dist/demo.css` // 临时做法，之后会取接口中的demo url
                const scriptDom = document.createElement('script');
                scriptDom.src = url;
                document.body.appendChild(scriptDom);
                const cssDom = document.createElement('script');
                cssDom.src = cssUrl;
                document.body.appendChild(cssDom); // 插入这两个静态资源文件
                return null;
            }
            case 'cdn':
                const { historyList, paginationInfo, page } = this.state
                return <div className='cdn-detail-table-container'>
                    <div>
                        <Row>
                            <Col md={1} xs={1} sm={1}>
                                <span className={'title'}>版本号：</span>
                            </Col>
                            <Col md={4} xs={4} sm={4}>
                                <FormControl
                                    style={{width:300}}
                                    value={this.state.searchVersion}
                                    onChange={(e) => this.setState({searchVersion: e})}
                                />
                            </Col>
                            <Col md={1} xs={1} sm={1}>
                                <span className={'title'}>时间：</span>
                            </Col>
                            <Col md={4} xs={4} sm={4}>
                                <RangePicker
                                    value={this.state.searchTime}
                                    onChange={(e) => this.setState({searchTime: e})}
                                    className={'cdn-range-picker'}
                                />
                            </Col>
                            <Col md={2} xs={2} sm={2}>
                                <Button style={{top: -4,}} onClick={() => {this.searchVersion()}}>查询</Button>
                                <Icon style={{marginLeft: 10, position: 'relative', fontSize: '24px', cursor: 'pointer'}} onClick={() => this.sync()} type="uf-sync-c-o" />
                            </Col>
                        </Row>
                    </div>
                    {
                        historyList.length === 0 ? <img src={noFile} /> :
                            <React.Fragment>
                                <Table
                                    className='cdn-detail-table'
                                    data={this.state.historyList}
                                    columns={this.historyColumns}
                                />
                                {
                                    historyList.length < 10 ? null :
                                        <Pagination
                                            prev
                                            next
                                            maxButtons={5}
                                            boundaryLinks
                                            activePage={page}
                                            onSelect={page => this.pageChange(page)}
                                            onDataNumSelect={this.dataNumSelect}
                                            showJump={true}
                                            dataNum={3}
                                            total={paginationInfo['count']}
                                        />
                                }
                            </React.Fragment>
                    }
                    </div>
            case 'api':
                return <div>
                    {
                        apiFile ?  <article className="markdown-body">
                            <div dangerouslySetInnerHTML={{__html: apiFile}}/>
                        </article>  : <img className='noFile' src={noFile} />
                    }
                </div>
            case 'changeLog':
                return <div>
                    {
                        changeLogFile ?  <article className="markdown-body">
                            <div dangerouslySetInnerHTML={{__html: changeLogFile}}/>
                        </article>  : <img className='noFile' src={noFile} />
                    }
                </div>;
            default:
                break;
        }
    };

    renderTabs = () => {
        const {activeTab, packageDetail} = this.state;
        const packageName = packageDetail.name
        this.tabs = [
            {
                key: 'readMe',
                name: '基本信息'
            },
            {
                key: 'api',
                name: 'API文档'
            },
            {
                key: 'demo',
                name: '典型案例'
            },
            {
                key: 'cdn',
                name: '版本与CDN资源'
            },
            {
                key: 'changeLog',
                name: '更新日志'
            },
        ];
        // if (packageName.startsWith('bee-')) {
        //     this.tabs.splice(2, 0, {
        //         key: 'demo',
        //         name: 'Demo'
        //     })
        // }
        const tabs = this.tabs.map(tab => {
            const handler = () => this.onChangeTab(tab.key);
            const isActive = activeTab === tab.key;
            const className = `${isActive ? 'active' : ''}`;
            return <span onClick={handler} className={className}>{tab.name}</span>;
        });
        return tabs;
    };
    getLoadingContainer = () => document.querySelector('body')

    render() {
        const {packageDetail, loading, activeTab}: { packageDetail: any, loading: boolean, activeTab: string} = this.state;
        const {identity, adminInfo=[], creatorInfo={}, developInfo=[]} = packageDetail;
        return (
            <div className='component-wrapper'>
                {
                    <React.Fragment>
                        <div className='component-info'>
                            {this.renderHeader(packageDetail, loading)}
                        </div>
                        <div className='component-detail'>
                            <div className='component-detail-tabs'>
                                {this.renderTabs()}
                            </div>
                            <div className='component-detail-info'>
                                <div id='tinperBeeDemo' style={activeTab === 'demo' ? {display: 'block'} : {display: 'none'}}></div>
                                {loading ? <Loading show={true} container={this.getLoadingContainer} /> : this.renderInfos(packageDetail, loading)}
                            </div>
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}
export default Layout(CollectionsDetail, 'block-collection-detail');
